import {
  TASK_START,
  COMPLETE
} from '@megaphonenpm/mputils/src/constants.js';

import {WatchableObject} from '@megaphonenpm/mputils/src/WatchableObject.js';
import {isNil} from '@megaphonenpm/mputils/src/utils.js';

/**
 * A simple watchable data source for statistics that appear in a DebugPanel instance.
 */
export class DebugModel extends WatchableObject {
  constructor () {
    super();
  }

  setBootManager (bootManager) {
    this.registerBootManagerListeners(bootManager);
  }

  registerBootManagerListeners (bootManager) {
    bootManager.on(TASK_START, e => {
        this.setStat('bootstate', 'Boot State', e.detail.name);
      });

    bootManager.on(COMPLETE, e => {
      this.setStat('bootstate', 'Boot State', 'Complete');
      this.setStat('bootduration', 'Boot Duration', `${e.detail.executionDuration/1000}s`);
    });
  }

  /**
   * Assigns the official application boot time, as a moment instance.
   *
   * @param time A moment instance.
   */
  setBootTime (time) {
    this.setStat('boottime', 'Boot Time', time);
  }

  setStat (name, label, value, health) {
    value = isNil(value) || value === '' ? '-' : value;
    this[name] = {label: label, value:value, health: health};
  }
}